import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';
import 'leaflet/dist/leaflet.css';
import Highcharts from 'highcharts';
import Charts from 'highcharts-vue';

// WebSocket-Client importieren
import socket from './websocket';

import './registerServiceWorker'

/*if ('serviceWorker' in navigator) {
  navigator.serviceWorker.register('/service-worker.js');
}*/

// Vue-App erstellen und konfigurieren
const app = createApp(App);
app.use(VueSweetalert2);
app.use(Highcharts);
app.use(Charts);
app.use(store);
app.use(router);

// Den WebSocket-Client als globale Eigenschaft in der Vue-App einfügen
app.config.globalProperties.$socket = socket;

// Vue-App an den DOM anhängen
app.mount('#app');
